import React from "react";
import { Dialog } from "primereact/dialog";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.css";

export default function DialogCalculatorAdmin({ showCalculatorModal, setShowCalculatorModal, persona, handleCotizacionSuccess, children }) {
    return (
        <Dialog
                header="Modificar Cotización"
                visible={showCalculatorModal}
                style={{ width: '80vw', borderRadius: '14px' }}
                onHide={() => setShowCalculatorModal(false)}
                maximizable
                modal
                contentStyle={{
                    borderRadius: '0 0 14px 14px',
                    width: '80vw',
                }}
                headerStyle={{
                    borderRadius: '14px 14px 0 0',
                }}
                draggable={false}
            >
                {children}
            </Dialog>
    )
}